<template>
    <ModalFormCard class="modal-default">
        <template #title>{{ subscription.location_area.name }}</template>

        <template #default="{ saving, errors }">
            <div class="w-full h-[300px]">
                <GoogleMap
                    ref="map"
                    :areas="[subscription.location_area]"
                    :area="subscription.location_area.id"
                    :subscription="subscription"
                />
            </div>

            <p class="mt-6 text-15">Locations</p>
            <div class="flex flex-wrap gap-2 mt-2">
                <!-- @mouseenter="$refs.map.goToPoint(loc)"
                @mouseleave="$refs.map.leavePoint()" -->

                <div
                    v-for="loc in locations"
                    class="px-4 py-1.5 border border-grey-500 text-13 font-semibold"
                >
                    {{ loc.name }}
                </div>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
import Modal from '~/mixins/modal.js'
import GoogleMap from '~/components/customer/blocks/google-map-old.vue'

export default {
    mixins: [Modal],
    computed: {
        subscription() {
            return this.editingModel
        },
        locations() {
            return this.options.locations
        },
    },

    components: {
        GoogleMap,
    },
}
</script>
